// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2dsy-","label":"CategoryService_label__VdxYi","location":"CategoryService_location__ZF6G5"};